import OpcaoSelecao from '@/components/base/OpcaoSelecao';
import type { ValorModo } from '../types';

interface SeletorValorProps {
  modo: ValorModo;
  onChange: (modo: ValorModo) => void;
  label?: string;
  notaADefinir?: string;
}

export default function SeletorValor({
  modo,
  onChange,
  label = 'Valor da inscrição',
  notaADefinir = 'A participação aparece na página do evento, mas ninguém consegue se inscrever até você informar o valor.',
}: SeletorValorProps) {
  return (
    <div>
      <span className="block text-[15px] font-medium text-foreground-950">
        {label}
      </span>
      <div className="mt-1">
        <OpcaoSelecao
          tipo="radio"
          checked={modo === 'gratuito'}
          onChange={() => onChange('gratuito')}
        >
          Gratuito
        </OpcaoSelecao>
        <OpcaoSelecao tipo="radio" checked={modo === 'pago'} onChange={() => onChange('pago')}>
          R$
        </OpcaoSelecao>
        <OpcaoSelecao
          tipo="radio"
          checked={modo === 'a_definir'}
          onChange={() => onChange('a_definir')}
        >
          Ainda não definimos
        </OpcaoSelecao>
      </div>
      {modo === 'a_definir' && (
        <p className="mt-2 text-sm text-secondary-500">{notaADefinir}</p>
      )}
    </div>
  );
}